module.exports = __webpack_public_path__ + "img/hkstpsaa.12e9d9e7.png";